import { Injectable } from '@angular/core';

function _window(): Window {
  return window;
}

@Injectable({
  providedIn: 'root',
})
export class WindowService {
  public get nativeWindow(): Window {
    return _window();
  }

  public openNewTab(url: string): void {
    this.nativeWindow.open(url, '_blank');
  }
}
